import { render, staticRenderFns } from "./Elmwood.vue?vue&type=template&id=486aaae8"
import script from "./Elmwood.vue?vue&type=script&lang=js"
export * from "./Elmwood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports